// Core
import { useState, useEffect, useCallback, useMemo } from 'react';
import { Flex, Button, Box, Image, Grid, Text, Switch, Spinner, useDisclosure, Input, Textarea } from '@chakra-ui/react';
import { useHistory } from 'react-router-dom';
import { useQuery } from 'react-query';
import { TiPlus } from 'react-icons/ti';
import { GrGallery } from 'react-icons/gr';

const ProfileGallery = ({
	object, 
}) => {

	return (
		<Box mt="40px" position="relative" w="100%">
			{/*<Box m="0 auto" w="300px" textAlign="center">
				<GrGallery color="rgb(14 22 51)" fontSize="34px" style={{ margin: '0 auto 0px auto'}} />
				<Text variant="title-lg" py="8px" fontSize="24px" pb="0px">Share your photos</Text>
				<Text variant="text-md" pb="16px">Complete your gallery 📸 to let people learn more about you and find the right person in you! 😊</Text>
				<Button variant="button-sm" w="180px" leftIcon={<TiPlus />} m="0 auto">Add</Button>
			</Box>*/}
		</Box>
	);
};

export default ProfileGallery;